import { Form, Input } from "antd";

const InputComponent = ({
  label,
  name,
  placeholder,
  rules,
  initialValue,
  onChange,
  disabled,
  validateTrigger,
  className
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      initialValue={initialValue}
      validateTrigger={validateTrigger}
    >
      <Input
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        className={className}
      />
    </Form.Item>
  );
};

InputComponent.defaultProps = {
  label: "",
  placeholder: "",
  rules: [],
  initialValue: null,
  disabled: false,
};

export default InputComponent;
